import { WebViewerInstance } from "@pdftron/webviewer";

type ViewerDocument = Document | undefined;

type WithUI = { UI?: { iframeWindow?: Window } };

export function getViewerDocument(instance: WebViewerInstance | null): ViewerDocument {
  if (!instance) return undefined;
  const ui = (instance as unknown as WithUI).UI;
  return ui?.iframeWindow?.document;
}


